export const WeblogScreenName = {
  CHAT_LIST: 'chat_list',
  CHAT_DETAIL: 'chat_detail',
  COMPANION_BRIDGE: 'companion_bridge',
} as const;

export const WeblogEventName = {
  CHAT_LIST: 'chat_list',
  ENTER_CHAT: 'enter_chat',
  CHECK_CUSTOM_ORDER: 'check_custom_order',
} as const;

export const WeblogPageCategory = {
  CHAT_LIST: '대화목록',
  CHAT_ROOM: '대화방',
} as const;
